import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { rangePriceValue } from "@utils/formControl";
import { centsToPrice } from "src/itsf/utils/priceUtils";

export const useMyBalancePayment = (amountToPay: number) => {
    const positiveAmount = parseFloat(centsToPrice(amountToPay));
    const handleRangePriceValue = rangePriceValue(0.02, positiveAmount);

    const formMethods = useForm<{ balance: string }>({ defaultValues: { balance: "" }, shouldUnregister: false });
    const { setValue } = formMethods;

    useEffect(() => {
        setValue("balance", positiveAmount.toFixed(2).toString());
    }, [positiveAmount, setValue]);

    return {
        formMethods,
        handleRangePriceValue,
    };
};
